import React, { Fragment } from 'react'

import RenditionGuide from '@/docs-partials/optional-settings/rendition-guide.mdx'
import ContentRating from '@/docs-partials/optional-settings/content-rating.mdx'
import LanguageSupport from '@/docs-partials/optional-settings/language-support.mdx'
import { DocsSection } from '@/components/common/docs-section'

const OptionalSettings = () => {
  return (
    <Fragment>
      <div className="docsContainer">
        <DocsSection dividerLine={false} anchorId="rendition-guide">
          <RenditionGuide />
        </DocsSection>
        <DocsSection anchorId="language-support">
          <LanguageSupport />
        </DocsSection>
        <DocsSection anchorId="rating">
          <ContentRating />
        </DocsSection>
      </div>
    </Fragment>
  )
}

export default OptionalSettings
